import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch,clearSearch } from '../../store/actions/search';
import { fetchCommonIssues, saveCommonIssue, updateCommonIssue, deleteCommonIssue } from '../../store/actions/CommonIssues';
import { selectCommonIssues } from '../../store/selectors/CommonIssues';
import { upload } from '../../helpers/upLoadHelper';
import CommonIssuesTable from '../../components/CommonIssuesTable';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { startFormLoading } from '../../store/actions/loader';

class ItemCommonIssues extends Component {
  componentDidMount(){
    const { item } = this.props;
    this.props.onFetchCommonIssues(item.id);
    this.props.clearSearch()
  }

  onSaveCommonIssue = async (data) => {
    const {  onSaveCommonIssue,onUpdateCommonIssue, item, user  } = this.props; 
    let params;
    if(data && data.id) {
      params = {
        'id': data.id,
        'subject': '',
        'description': data.description,
        'issueTypeId': data.issueTypeId,
        'userId': user.id,
        'itemId': item.id
      }
    } else {
    params = {
      'subject': '',
      'description': data.description,
      'issueTypeId': data.issueTypeId,
      'userId': user.id,
      'itemId': item.id
    }
  }
    if(data && data.attachment && data.attachment.length > 0) {
      this.props.startFormLoading();
    await this.handleMultipleUpload(data.attachment, function (resObj) {
      params.attachment = JSON.stringify(resObj).toString()
      if(data && data.id) {
        onUpdateCommonIssue(params);
      } else {
        onSaveCommonIssue(params);
      }
    })
    } else {
      params.attachment = ""
      if(data && data.id) {
        onUpdateCommonIssue(params);
      } else {
        onSaveCommonIssue(params);
      }
    }
  }
  
  handleMultipleUpload = async (selectedImage, callback) => {
    let uploadImages = [];
    for (let i = 0; i < selectedImage.length; i++) {
      if(selectedImage[i] && selectedImage[i].url) {
        uploadImages.push(selectedImage[i])
      } else {
      await this.uploadimg(selectedImage[i], (imgData) => {
        uploadImages.push(imgData);
      });
    }
    }
    callback(uploadImages)
  }
   // function to upload the images into aws
   uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile)
    let object = {
      url: imageUrl,
      title: imageUrl.split('.com/')[1]
    }
    callback(object);
  }
  onDeleteCommonIssue = (id) => {
    this.props.onDeleteCommonIssue(id)
  }
  render() {
    const { commonIssues, item,setSearch, loader } = this.props;
    return (
      loader ? <Loader />
      : <CommonIssuesTable
        breadcrumb={item.name}
        commonIssues={commonIssues}
        onSaveCommonIssue={this.onSaveCommonIssue}
        onDeleteCommonIssue={this.onDeleteCommonIssue}
        onSearch={e => setSearch({ commonIssues: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  commonIssues: selectCommonIssues(state),
  user: selectAuthenticatedUser(state),
  loader: selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchCommonIssues: fetchCommonIssues,
  onSaveCommonIssue: saveCommonIssue,
  onUpdateCommonIssue: updateCommonIssue,
  onDeleteCommonIssue:deleteCommonIssue,
  startFormLoading,
  setSearch,
  clearSearch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemCommonIssues);
